import {
  createI18n
} from 'vue-i18n'
import chLocale from './ch'
import enLocale from './en'
import elEnLocale from 'element-plus/lib/locale/lang/en'
import elChLocale from 'element-plus/lib/locale/lang/zh-cn'
const i18n = createI18n({
  locale:sessionStorage.getItem("lang") || 'en',
  silentFallbackWarn: true,
  legacy: false,
  globalInjection: true, 
  messages: {
    ch: {
      ...chLocale,
      el: elChLocale.el
    },
    en: {
      ...enLocale,
      el: elEnLocale.el
    }
  }
})

export default i18n;